/** Referências dos arquivos */
export interface ArquivoReferencia {
    id: number;
    nome: string;
}

export const arquivoReferenciaCliente: ArquivoReferencia = {id: 1, nome: 'Clientes'};
export const arquivoReferenciaCampanha: ArquivoReferencia = {id: 2, nome: 'Campanhas'};
export const arquivoReferenciaNegocio: ArquivoReferencia = {id: 3, nome: 'Negócios'};
export const arquivoReferenciaCotacao: ArquivoReferencia = {id: 4, nome: 'Cotações'};
export const arquivoReferenciaPedido: ArquivoReferencia = {id: 5, nome: 'Pedidos'};
export const arquivoReferenciaPedidoItem: ArquivoReferencia = {id: 6, nome: 'Pedidos Itens'};
export const arquivoReferenciaPedidoExpedicao: ArquivoReferencia = {id: 7, nome: 'Pedidos Expedição'};
export const arquivoReferenciaOrcamento: ArquivoReferencia = {id: 8, nome: 'Orçamentos'};

export const arquivosReferencias: ArquivoReferencia[] = [
    arquivoReferenciaCliente,
    arquivoReferenciaCampanha,
    arquivoReferenciaNegocio,
    arquivoReferenciaCotacao,
    arquivoReferenciaOrcamento,
    arquivoReferenciaPedido,
    arquivoReferenciaPedidoItem,
    arquivoReferenciaPedidoExpedicao
];

/** Verifica se a a referência é cliente */
export function isArquivoReferenciaCliente(referencia: number): boolean {
    if (!referencia) {
        return false;
    }
    return referencia === arquivoReferenciaCliente.id;
}

/** Verifica se a a referência é campanha */
export function isArquivoReferenciaCampanha(referencia: number): boolean {
    if (!referencia) {
        return false;
    }
    return referencia === arquivoReferenciaCampanha.id;
}

/** Verifica se a a referência é negócio */
export function isArquivoReferenciaNegocio(referencia: number): boolean {
    if (!referencia) {
        return false;
    }
    return referencia === arquivoReferenciaNegocio.id;
}

/** Verifica se a a referência é cotação */
export function isArquivoReferenciaCotacao(referencia: number): boolean {
    if (!referencia) {
        return false;
    }
    return referencia === arquivoReferenciaCotacao.id;
}

/** Verifica se a a referência é pedido */
export function isArquivoReferenciaPedido(referencia: number): boolean {
    if (!referencia) {
        return false;
    }
    return referencia === arquivoReferenciaPedido.id;
}

/** Verifica se a a referência é pedido item */
export function isArquivoReferenciaPedidoItem(referencia: number): boolean {
    if (!referencia) {
        return false;
    }
    return referencia === arquivoReferenciaPedidoItem.id;
}

/** Verifica se a a referência é pedido expedição */
export function isArquivoReferenciaPedidoExpedicao(referencia: number): boolean {
    if (!referencia) {
        return false;
    }
    return referencia === arquivoReferenciaPedidoExpedicao.id;
}

/** Verifica se a a referência é orçamento */
export function isArquivoReferenciaOrcamento(referencia: number): boolean {
    if (!referencia) {
        return false;
    }
    return referencia === arquivoReferenciaOrcamento.id;
}
